import { Button, Divider, Flex, Image, Text } from "@fluentui/react-northstar";
import styled from "styled-components";

export const Background = styled(Flex)`
    background-image: url("/bg/background-login.svg");
    background-position: center;
    width: 100vw;
    height: 100vh;
`;

export const Card2FA = styled(Flex)`
    width: 719px;
    height: 770px;

    border-radius: 12px;
    background: var(--Light-theme-Rest-Background-Default-Background, #fff);

    /* shadow-8 */
    box-shadow: 0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.11),
        0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13);
`;

export const LogoImage = styled(Image)`
    height: 56px;
`;

export const IllustrationSignin = styled(Image)``;

export const ButtonGetHelp = styled(Button)`
    color: var(--Blue-link, #0067b8);

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
`;
export const TextAnyProblem = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;
export const DividerWrapper = styled(Flex)`
    width: 260px;
`;
export const DividerStyle = styled(Divider)`
    width: 100%;
`;
